import React, { useState } from "react";
import ItemWhModal from "../Modal/ItemWhModal";
import { formatCurrency } from "../../../utils/SamuiUtils";
import FileModalV2 from "../Modal/FileModal2";

const ItemWhTable = ({
  mode,
  showItemModal,
  handleItemClose,
  itemDataList,
  onRowSelectItem,
  formDetailList,
  handleItemShow,
  handleQuantityChange,
  handleFocus,
  handleBlur,
  handleRemoveRow,
  disabled,
  selectedFiles,
  setSelectedFiles,
  warehouseId,
}) => {
  // const [selectedFiles, setSelectedFiles] = useState([]);
  const [showFileModal, setShowFileModal] = useState(false);
  const [openUploadAttach, setOpenUploadAttach] = useState(false);

  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    if (selectedFiles.length === 0) {
      setOpenUploadAttach(false);
    }
  };

  const handleKeyDown = (e, currentIndex, fieldType) => {
    // Arrow Up/Down: Navigate between rows (same field type)
    if (e.key === "ArrowUp" && currentIndex > 0) {
      e.preventDefault();
      const targetIndex = currentIndex - 1;
      const targetInput = document.querySelector(
        `input[data-row-index="${targetIndex}"][data-field-type="${fieldType}"]`
      );
      if (targetInput) {
        targetInput.focus();
        targetInput.select();
      }
    } else if (e.key === "ArrowDown" && currentIndex < formDetailList.length - 1) {
      e.preventDefault();
      const targetIndex = currentIndex + 1;
      const targetInput = document.querySelector(
        `input[data-row-index="${targetIndex}"][data-field-type="${fieldType}"]`
      );
      if (targetInput) {
        targetInput.focus();
        targetInput.select();
      }
    }
    // Arrow Left/Right: Navigate between increase and decrease fields (same row)
    else if (e.key === "ArrowRight" && fieldType === "increase") {
      e.preventDefault();
      const targetInput = document.querySelector(
        `input[data-row-index="${currentIndex}"][data-field-type="decrease"]`
      );
      if (targetInput) {
        targetInput.focus();
        targetInput.select();
      }
    } else if (e.key === "ArrowLeft" && fieldType === "decrease") {
      e.preventDefault();
      const targetInput = document.querySelector(
        `input[data-row-index="${currentIndex}"][data-field-type="increase"]`
      );
      if (targetInput) {
        targetInput.focus();
        targetInput.select();
      }
    }
  };

  // function handleInputFileChange(e) {
  //   const files = Array.from(e.target.files);
  //   const fileReaders = files.map((file) => {
  //     return new Promise((resolve) => {
  //       const reader = new FileReader();
  //       reader.onload = (ev) =>
  //         resolve({
  //           name: file.name,
  //           type: file.type,
  //           size: file.size,
  //           dataUrl: ev.target.result,
  //           isPending: true,
  //         });
  //       reader.readAsDataURL(file);
  //     });
  //   });

  //   Promise.all(fileReaders).then((results) => {
  //     setSelectedFiles((prev) => [...prev, ...results]);
  //   });
  // }

  const handleFileSelection = (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    const filePromises = files.map((file, index) => {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          resolve({
            id: Date.now() + index + Math.random(),
            name: file.name,
            type: file.type,
            size: file.size,
            file: file,
            dataUrl: e.target.result,
            isPending: true,
            displayName: file.name,
          });
        };

        reader.onerror = () => {
          resolve({
            id: Date.now() + index + Math.random(),
            name: file.name,
            type: file.type,
            size: file.size,
            file: file,
            dataUrl: URL.createObjectURL(file),
            isPending: true,
            displayName: file.name,
            useObjectUrl: true,
          });
        };

        reader.readAsDataURL(file);
      });
    });

    Promise.all(filePromises)
      .then((processedFiles) => {
        const updatedFiles = [...selectedFiles, ...processedFiles];
        setSelectedFiles(updatedFiles);
        setShowFileModal(true); //  แสดง modal ได้เลย ไม่ต้องเรียก handleInputFileChange
      })
      .catch((error) => {});

    event.target.value = "";
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="card-title">รายละเอียดสินค้า</h4>
        <div style={{ display: "flex", alignItems: "center" }}>
          {window.location.pathname === "/treasury-documents" && (
            <>
              {selectedFiles.length > 0 ? (
                <div>
                  <button
                    className="btn text-white"
                    style={{
                      backgroundColor: "rgb(239, 108, 0)",
                      whiteSpace: "nowrap",
                      padding: "12px",
                      fontSize: "15px",
                      // borderRadius: "8px",
                      border: "none",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    disabled={disabled}
                    onClick={
                      () => setShowFileModal(true)
                      // document.getElementById("file-upload-input").click()
                    }
                  >
                    <i className="fa fa-paperclip"></i>
                    ดูไฟล์ ({selectedFiles?.length})
                  </button>
                </div>
              ) : (
                <div>
                  <input
                    type="file"
                    multiple
                    accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.mp4,.avi,.mov,.mp3,.wav"
                    onChange={handleFileSelection}
                    style={{ display: "none" }}
                    id="file-upload-input"
                  />
                  <button
                    className="btn text-white"
                    style={{
                      backgroundColor: "rgb(239, 108, 0)",
                      whiteSpace: "nowrap",
                      padding: "11px 20px",
                      fontSize: "15px",
                      // borderRadius: "8px",
                      border: "none",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    disabled={disabled}
                    onClick={() =>
                      document.getElementById("file-upload-input").click()
                    }
                  >
                    <i className="fa fa-paperclip"></i>
                    แนบไฟล์
                  </button>
                </div>
              )}
            </>
          )}
          <button
            className="btn text-white mx-3"
            onClick={handleItemShow}
            style={{
              backgroundColor: "rgb(239, 108, 0)",
              whiteSpace: "nowrap",
              padding: "10px",
              fontSize: "15px",
            }}
            disabled={disabled}
          >
            <i className="fa fa-plus"></i> เพิ่มรายการ
          </button>
        </div>
      </div>
      <ItemWhModal
        formDetailList={formDetailList}
        showItemModal={showItemModal}
        handleItemClose={handleItemClose}
        itemDataList={itemDataList}
        onRowSelectItem={onRowSelectItem}
        warehouseId={warehouseId}
      />
      <div className="card-body">
        <div
          className="table-responsive"
          style={{ maxHeight: "500px", overflowY: "auto" }}
        >
          <table
            id="basic-datatables"
            className="table table-striped table-hover"
          >
            <thead className="thead-dark">
              <tr>
                <th className="text-center" style={{ width: "2%" }}>
                  #
                </th>
                <th className="text-center" style={{ width: "8%" }}>
                  รหัสสินค้า
                </th>
                <th
                  className="text-center"
                  style={
                    mode === "FA" || mode === "WDP"
                      ? { width: "30%" }
                      : { width: "40%" }
                  }
                >
                  ชื่อสินค้า
                </th>
                <th className="text-center" style={{ width: "10%" }}>
                  Todo
                </th>
                <th className="text-center" style={{ width: "10%" }}>
                  จำนวนคงคลัง
                </th>

                {mode === "FA" || mode === "WDP" ? (
                  <>
                    {mode === "WDP" ? null : (
                      <th className="text-center" style={{ width: "10%" }}>
                        เพิ่ม
                      </th>
                    )}

                    <th className="text-center" style={{ width: "10%" }}>
                      เบิก
                    </th>
                  </>
                ) : (
                  <th className="text-center" style={{ width: "10%" }}>
                    จำนวน
                    {window.location.pathname === "/picking-list" ||
                    window.location.pathname === "/bill-of-lading"
                      ? "เบิก"
                      : ""}
                  </th>
                )}

                <th className="text-center" style={{ width: "10%" }}>
                  จำนวนคงเหลือ
                </th>
                <th className="text-center" style={{ width: "5%" }}>
                  หน่วย
                </th>
                <th className="text-center" style={{ width: "5%" }}>
                  ลบ
                </th>
              </tr>
            </thead>
            <tbody>
              {formDetailList.length > 0 ? (
                formDetailList.map((item, index) => (
                  <tr key={item.itemId || index + 1}>
                    {/* # */}
                    <td className="text-center">{index + 1}</td>

                    {/* รหัสสินค้า */}
                    <td className="text-center">
                      <span>{item.itemCode || ""}</span>
                    </td>

                    {/* ชื่อสินค้า */}
                    <td className="text-left">
                      <span>{item.itemName || ""}</span>
                    </td>

                    {/* Todo */}
                    <td className="text-center">
                      <span>{item.docType || ""}</span>
                    </td>

                    {/* จำนวนคงคลัง */}
                    <td className="text-center">
                      <span>{item.itemOnHand || 0}</span>
                    </td>

                    {mode === "FA" || mode === "WDP" ? (
                      <>
                        {/* เพิ่ม */}
                        {mode === "WDP" ? null : (
                          <td className="text-center">
                            <input
                              type="text"
                              className="form-control text-center"
                              value={item.itemIncrease || ""}
                              data-row-index={index}
                              data-field-type="increase"
                              onChange={(e) =>
                                handleQuantityChange(
                                  index,
                                  "increase",
                                  e.target.value,
                                  item.itemOnHand
                                )
                              }
                              onClick={(e) => {
                                setTimeout(() => e.target.select(), 0);
                              }}
                              onFocus={(e) => {
                                handleFocus(index, "itemIncrease");
                                setTimeout(() => e.target.select(), 0);
                              }}
                              onBlur={(e) =>
                                handleBlur(
                                  index,
                                  "itemIncrease",
                                  e.target.value
                                )
                              }
                              onKeyDown={(e) => handleKeyDown(e, index, "increase")}
                              onInput={(e) => {
                                const inputValue = e.target.value;
                                if (
                                  !/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)
                                ) {
                                  e.target.value = inputValue.slice(0, -1);
                                }
                              }}
                            />
                          </td>
                        )}
                        {/* ลด */}
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control text-center"
                            value={item.itemDecrease || ""}
                            data-row-index={index}
                            data-field-type="decrease"
                            onChange={(e) =>
                              handleQuantityChange(
                                index,
                                "decrease",
                                e.target.value,
                                item.itemOnHand
                              )
                            }
                            onClick={(e) => {
                              setTimeout(() => e.target.select(), 0);
                            }}
                            onFocus={(e) => {
                              handleFocus(index, "itemDecrease");
                              setTimeout(() => e.target.select(), 0);
                            }}
                            onBlur={(e) =>
                              handleBlur(index, "itemDecrease", e.target.value)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index, "decrease")}
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                e.target.value = inputValue.slice(0, -1);
                              }
                            }}
                          />
                        </td>
                      </>
                    ) : (
                      <>
                        {/* จำนวน */}
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control text-center"
                            value={item.itemDecrease || ""}
                            data-row-index={index}
                            data-field-type="decrease"
                            onChange={(e) =>
                              handleQuantityChange(
                                index,
                                "decrease",
                                e.target.value,
                                item.itemOnHand
                              )
                            }
                            onClick={(e) => {
                              setTimeout(() => e.target.select(), 0);
                            }}
                            onFocus={(e) => {
                              handleFocus(index);
                              setTimeout(() => e.target.select(), 0);
                            }}
                            onBlur={(e) => handleBlur(index)}
                            onKeyDown={(e) => handleKeyDown(e, index, "decrease")}
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                e.target.value = inputValue.slice(0, -1);
                              }
                            }}
                            disabled={
                              window.location.pathname === "/icebox"
                                ? true
                                : false
                            }
                          />
                        </td>
                      </>
                    )}

                    {/* จำนวนคงเหลือ */}
                    <td className="text-center">
                      <span>{formatCurrency(item.itemBalance) || 0}</span>
                    </td>

                    {/* หน่วย */}
                    <td className="text-center">
                      <span>{item.itemUnit || ""}</span>
                    </td>

                    {/* ลบ */}
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => handleRemoveRow(index)}
                      >
                        ลบ
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10">
                    <center>
                      <h5>ไม่พบรายการสินค้า</h5>
                    </center>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <FileModalV2
          // mode="S" // โหมดดูอย่างเดียว
          showViewAttachModal={showFileModal}
          setShowViewAttachModal={setShowFileModal}
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
          selectedRecFiles={[]}
          openUploadAttach={openUploadAttach}
          handleRemoveImage={handleRemoveImage}
        />
      </div>
    </div>
  );
};

export default ItemWhTable;
